'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'video-plus';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f4e1';
var svgPathData = 'M368 80l0 88 0 176 0 88L16 432 16 80l352 0zm16 352l0-80 0-17.9 0-156.2 0-17.9 0-80 0-16-16 0L16 64 0 64 0 80 0 432l0 16 16 0 352 0 16 0 0-16zm176-9.9l-144-72 0 17.9 144 72 16 8 0-17.9 0-348.2L576 64l-16 8L416 144l0 17.9 144-72 0 332.2zM200 168l0-8-16 0 0 8 0 80-80 0-8 0 0 16 8 0 80 0 0 80 0 8 16 0 0-8 0-80 80 0 8 0 0-16-8 0-80 0 0-80z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faVideoPlus = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;